import React from 'react';
import { MDBCard, MDBCardBody, MDBBadge, MDBIcon } from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ENTITY_CONFIG, LECTURE_SUB_TYPES } from './chatbotConfig';

export default function SourceCard({ source, sourceIndex }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const { entityType, subType, entity, score, externalDocumentId } = source;
  const config = ENTITY_CONFIG[entityType];

  if (!config) {
    return (
      <MDBCard className="mb-2 border">
        <MDBCardBody className="p-2 d-flex align-items-center">
          <MDBBadge className="me-2" color="secondary">{sourceIndex}</MDBBadge>
          <small className="text-muted">{externalDocumentId || 'Unbekannte Quelle'}</small>
        </MDBCardBody>
      </MDBCard>
    );
  }

  const displayName = entity
    ? config.getDisplayName(entity, lang)
    : externalDocumentId;
  const imageFileName = entity ? config.getImage(entity) : null;
  const imageUrl = config.imageUrl(imageFileName);
  const companyName = entity ? config.getCompanyName(entity) : null;
  const adminPath = entity ? config.adminPath(entity) : null;
  const scorePercent = score ? Math.round(score * 100) : null;

  const cardContent = (
    <div className="d-flex align-items-center">
      {/* Image or icon */}
      <div
        className="me-3 d-flex align-items-center justify-content-center flex-shrink-0"
        style={{ width: 48, height: 48 }}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={displayName}
            style={{ width: 48, height: 48, objectFit: 'contain', borderRadius: 4 }}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        ) : (
          <MDBIcon
            fas
            icon={config.icon}
            size="2x"
            className="text-muted"
          />
        )}
      </div>

      {/* Info */}
      <div className="flex-grow-1 overflow-hidden">
        <div className="d-flex align-items-center gap-1 mb-1 flex-wrap">
          <MDBBadge color="dark" className="me-1" style={{ fontSize: '0.65rem' }}>
            {sourceIndex}
          </MDBBadge>
          <MDBBadge color={config.color} style={{ fontSize: '0.65rem' }}>
            {config.label}
          </MDBBadge>
          {subType && LECTURE_SUB_TYPES[subType] && (
            <MDBBadge color="light" className="text-dark" style={{ fontSize: '0.65rem' }}>
              {LECTURE_SUB_TYPES[subType]}
            </MDBBadge>
          )}
          {scorePercent !== null && (
            <small className="text-muted ms-1" style={{ fontSize: '0.7rem' }}>
              {scorePercent}%
            </small>
          )}
        </div>
        <div
          className="fw-bold text-truncate"
          style={{ fontSize: '0.85rem' }}
          title={displayName}
        >
          {entity ? displayName : <span className="text-muted fst-italic">Nicht gefunden</span>}
        </div>
        {companyName && (
          <small className="text-muted">{companyName}</small>
        )}
      </div>

      {/* Link arrow */}
      {adminPath && (
        <MDBIcon fas icon="external-link-alt" className="text-muted ms-2 flex-shrink-0" />
      )}
    </div>
  );

  return (
    <MDBCard className="mb-2 border source-card" style={{ cursor: adminPath ? 'pointer' : 'default' }}>
      <MDBCardBody className="p-2">
        {adminPath ? (
          <Link to={adminPath} className="text-reset text-decoration-none" target="_blank">
            {cardContent}
          </Link>
        ) : (
          cardContent
        )}
      </MDBCardBody>
    </MDBCard>
  );
}
